import { useState, useEffect, useCallback } from "react";

const SIZES = [100, 106, 112, 118]; // percentage

export const useTextSize = () => {
  const [level, setLevel] = useState(() => {
    if (typeof window === "undefined") return 0;
    return Number(localStorage.getItem("vantastika-textsize") || "0");
  });

  useEffect(() => {
    document.documentElement.style.fontSize = `${SIZES[level]}%`;
    localStorage.setItem("vantastika-textsize", String(level));
  }, [level]);

  const increase = useCallback(() => setLevel((l) => Math.min(l + 1, SIZES.length - 1)), []);
  const decrease = useCallback(() => setLevel((l) => Math.max(l - 1, 0)), []);

  return { level, increase, decrease };
};
